import React, {  } from "react";
import "./SystemStatus.scss";
import SystemStatusResourceInfo from "./SystemStatusResourceInfo";
import { SpintrTypes } from "src/typings";
import { Style } from "src/ui/helpers";
import { Label } from "src/ui";
import { decodeHtmlEntities, formatInteractiveText, fromNow } from "src/utils";
import SystemStatusResourceCTA from "./SystemStatusResourceCTA";
import { localize } from "src/l10n";
import moment from "moment";
import { Link } from "react-router-dom";
import { Conditional } from "src/components/Conditional";
import classNames from "classnames";
import ShowMoreText from "react-show-more-text";

interface IProps {
    resource: Spintr.ISystemStatusResource;
    systemStatus: any;
}

const SystemStatus = (props: IProps) => {
    const renderInfoRow = (key: string, value: string, valueTitle?: string, className?: string | undefined) => {
        return (
            <div className={classNames("info-row", className)}>
                <Label size="body-2" color="grey">{key}</Label>
                <Label className="value-cell" size="body-2" color="dark-grey" title={valueTitle}>{value}</Label>
            </div>
        )
    }

    return (
        <Link
            className="SystemStatus"
            to={"/operations/" + props.resource.id}>
            <div className="segment">
                <SystemStatusResourceInfo resource={{
                    ...props.resource,
                    status: props.systemStatus.status
                }} />
            </div>
            <div className="segment">
                {props.systemStatus.text && (
                    <Label 
                        as="div"
                        color="dark-grey"
                        className="general-row-break interactive-text feed-post-text"
                        size="body-2"
                    >
                        <ShowMoreText
                            lines={3}
                            more={localize("VisaMer")}
                            less={localize("VisaMindre")}
                            expanded={false}
                        >
                            {formatInteractiveText(
                                decodeHtmlEntities(props.systemStatus.text)
                            )}
                         </ShowMoreText>
                    </Label>
                )}
                <div className="footer-button">
                    <SystemStatusResourceCTA
                        resource={props.resource}
                        systemStatusPostId={props.systemStatus.postId || props.resource.lastSystemStatusPostId} />
                </div>
            </div>
            <div className="segment info-segment">
                <div className="info">
                    {renderInfoRow(localize("Status"), localize(
                        props.systemStatus.status === SpintrTypes.SystemStatusType.AllClear
                            ? "ALL_CLEAR"
                            : props.systemStatus.status === SpintrTypes.SystemStatusType.Ongoing
                            ? "Pagaende"
                            : props.systemStatus.status === SpintrTypes.SystemStatusType.Planned
                            ? "Planerad"
                            : "Avklarad"
                    ))}
                    {renderInfoRow(localize("Start"), fromNow(props.systemStatus.startDate), moment(props.systemStatus.startDate).format("LLL"))}
                    {props.systemStatus.endDate && renderInfoRow(localize("Slut"), fromNow(props.systemStatus.endDate), moment(props.systemStatus.endDate).format("LLL"))}
                    {props.systemStatus.responsibleUser && renderInfoRow(localize("RESPONSIBLE_PERSON"), props.systemStatus.responsibleUser.name)}
                </div>
            </div>
        </Link>
    )
}

export default SystemStatus;
